/**
 * Отправляет данные формы на сервер без перезагрузки страницы
 *
 * @param {Object} options
 * @param {String} options.url Адрес отправки
 * @param {FormData} options.data Данные для отправки
 * @param {function(Object)} options.success Вызывается при успешном завершении запроса
 * @param {function(Object)} options.error Вызывается при ошибке
 */
function postData(options) {
  const request = new XMLHttpRequest();
  request.open("POST", options.url);
  
  request.onreadystatechange = function() { 
    if (request.readyState !== 4) return;

    if (request.status !== 200) {
      options.error(request.statusText);
      return;
    }

    const responseType = request.getResponseHeader("Content-Type");
    
    if (responseType.indexOf("xml") !== -1 && request.responseXML)
      options.success(request.responseXML);
    else if (responseType.indexOf("application/json") !== -1)
      options.success(JSON.parse(request.responseText)); 
    else
      options.success(request.responseText)
  };

  request.send(options.data); 
}

export default postData;